import * as http from './http';

// 企业所属领域
export const companyDictCate = () => http.post(`/company/dict/cate`, '');
export const companyInfo = (params) => http.post(`/company/info/my`, params);
export const companyUpdate = (params) => http.post(`/company/info/update`, params);
export const companyUpdateIncrement = (params) => http.post(`/company/info/update-increment`, params);
export const companyDictRevenue = (params) => http.post(`/company/dict/revenue`, params);
// 根据父ID 获取子地区集合
export const registeRarea = (params) => http.post('/dict/children', params, {loading: false})
